export default __webpack_public_path__ + "static/media/sunspots.1fb9c9e6.svg";